import React from 'react';
import { Link } from 'react-router-dom';

export default class SharedFooter extends React.Component {

  render() {
    return (
      <footer>
        <div className="k-f-img"></div>
        <div className="k-footer-wrap">
          <div className="k-footer-flex">
            <div className="k-footer-flex-item1">
              <p className="ma">名古屋市住宅都市局<br />
                建築指導部建築指導課</p>
              <p className="add">開庁時間:月曜日から金曜日 8時45分から17時15分まで<br />(祝日・休日・年末年始を除く)<br />
                〒460-8508　名古屋市中区三の丸三丁目1番1号<br />
                電話番号：052-972-2928 ファックス番号：052-972-4159 </p>
              <p className="copy">Copyright © Nagoya City Building Inspection Division All rights reserved.</p>
            </div>
            <div className="k-footer-flex-item2 pc">
              <nav className="footer-nav">
                <ul className="f-nav">
                  <li><Link to="/kenchiku/dousa">動作環境</Link></li>
                  <li><Link to="/kenchiku/manual">操作説明</Link></li>
                  <li><Link to="/kenchiku/faq">疑問・質問</Link></li>
                </ul>
              </nav>
              <div className="link-wrap">
                <p>関連リンク</p>
                <ul className="link">
                  <li><Link to="/nagoya/">名古屋市指定道路図</Link></li>
                  <li><a href="https://www.sonicweb-asp.jp/nagoya/" target="_blank">名古屋市道路認情報サービス</a></li>
                  <li><a href="https://www2.wagmap.jp/nagoya-tokei/" target="_blank">名古屋市都市計画情報提供サービス</a></li>
                  <li><a href="https://www.city.nagoya.jp/jigyou/category/39-6-4-9-0-0-0-0-0-0.html" target="_blank">建築情報マップの概要</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }

}